import { render, staticRenderFns } from "./MessageMemberJoined.vue?vue&type=template&id=77c3b2f2&"
import script from "./MessageMemberJoined.vue?vue&type=script&lang=js&"
export * from "./MessageMemberJoined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports